import React, { useContext } from "react";

import classnames from "classnames";
import chunk from "lodash/chunk";

import { SearchContext } from "components/store/source";
import {
  toggleAmenity,
  setHighlightListings,
} from "components/store/source/actions/searchCriteriaActions";
import { Checkbox, Section, Spacer, Text } from "components/ui/source";

import { SearchAmenityFilter } from "types/graphql";

import styles from "./AmenitiesCheckBoxes.module.scss";

type AmenitiesCheckBoxesProps = {
  data?: Partial<SearchAmenityFilter>;
  onClick?(): void;
  isMobile?: boolean;
};

export function AmenitiesCheckBoxes({
  data = { options: [], selected: [] },
  onClick = () => {},
  isMobile = false,
}: AmenitiesCheckBoxesProps) {
  const { dispatch } = useContext(SearchContext);
  const { options, selected } = data;

  const onToggleCheckbox = event => {
    const key = event.target.id;
    const value = event.target.checked;
    dispatch(toggleAmenity({ [key]: value }));
    dispatch(setHighlightListings(false));
    if (!isMobile) {
      onClick();
    }
  };

  const titleClass = classnames(
    styles.dropdown_title,
    isMobile && styles["dropdown_title--mobile"],
  );

  return (
    <>
      <div className={titleClass}>
        <Text
          translateKey="filters.amenitiesFilters.title_other_features"
          types={["medium", "caption1"]}
        />
      </div>
      {isMobile && <Spacer size="s-2x" />}
      <Section verticalPosition="start" horizontalPosition="space-between">
        {chunk(options, 5).map((partition, i) => (
          <div key={`amenities_column_${i}`}>
            {partition.map(({ label, value }) => (
              <Checkbox
                key={value}
                id={value}
                label={label}
                name={value}
                checked={selected.some(
                  ({ value: selectedValue }) => selectedValue === value,
                )}
                onChange={onToggleCheckbox}
                noForm
                className={styles.checkbox_container}
              />
            ))}
          </div>
        ))}
      </Section>
    </>
  );
}
